import React from 'react';
import { X } from 'lucide-react';

const SqlQueryModal = ({ isOpen, onClose, query }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[80vh] flex flex-col">
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-lg font-semibold text-primary">SQL Query</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            type="button"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-4 overflow-auto flex-grow">
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-x-auto whitespace-pre-wrap">
            {query || 'No SQL query available'}
          </pre>
        </div>
        <div className="border-t p-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
            type="button"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SqlQueryModal;